import { styled, Badge } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import CloseIcon from '@mui/icons-material/Close';

export const BurgerIcon = styled(MenuIcon)`
  ${theme.breakpoints.up('lg')} {
    display: none;
  }
`;

export const Header = styled(ListItem)`
  background: ${theme.palette.neutral.main};
  height: 54px;
  justify-content: flex-end;
`;

export const StyledCloseIcon = styled(CloseIcon)``;

export const StyledBadge = styled(Badge)`
  ${theme.breakpoints.up('lg')} {
    display: none;
  }
`;
